import Echo from '@ably/laravel-echo';

import { WebsocketService } from '../websockets';

type PublicChannel = ReturnType<Echo['channel']>;

/**
 * Public (unauthenticated) channels. Currently used for the `documents.{id}` and
 * `list` channels, which the backend broadcasts on public channels. See the
 * "document/list channels are public" concern in docs/WEBSOCKET_REFACTOR.md;
 * this service should be removed once those move to private.
 */
export class PublicEchoWebsocketService extends WebsocketService<PublicChannel> {
  constructor() {
    super({
      channelApi: {
        connect: (echo, channelName) => echo.channel(channelName),
        leave: (echo, channelName) => echo.leave(channelName),
        listen: (channel, eventName, handler) => {
          channel.listen(eventName, handler);
        },
        stopListening: (channel, eventName, handler) => {
          channel.stopListening(eventName, handler);
        },
      },
    });
  }
}
